import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  container: {
    width: '100%'
  } satisfies SxProps<Theme>,
  paper: {
    mb: 3
  } satisfies SxProps<Theme>,
  header: {
    display: 'flex',
    alignItems: 'center',
    mb: 2
  } satisfies SxProps<Theme>,
  title: {
    fontWeight: 'bold',
    fontSize: '1.1rem',
    wordBreak: 'break-word',
    minWidth: 0
  } satisfies SxProps<Theme>,
  questionWrapper: {
    mb: 2
  } satisfies SxProps<Theme>,
  addButton: {
    textTransform: 'none',
    mt: 1
  } satisfies SxProps<Theme>,
  groupTitle: {
    mb: '16px'
  } satisfies SxProps<Theme>,
  compactPaper: {
    mb: 0
  } satisfies SxProps<Theme>,
  compactHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '480px',
    maxWidth: '100%',
    mb: '8px'
  } satisfies SxProps<Theme>,
  compactTitle: {
    wordBreak: 'break-word',
    minWidth: 0
  } satisfies SxProps<Theme>,
  compactRemoveButton: {
    p: 0,
    color: 'var(--blue-500)',
    '& svg': { fontSize: '24px' }
  } satisfies SxProps<Theme>,
  compactAddButton: {
    textTransform: 'none',
    p: '5px 0',
    minWidth: 0,
    fontFamily: 'Raleway',
    fontWeight: 600,
    fontSize: '16px',
    color: 'var(--grey-900)',
    '& .MuiButton-endIcon': { ml: '10px', mr: 0 },
    '& .MuiButton-endIcon svg': { fontSize: '16px', color: 'var(--blue-700)' }
  } satisfies SxProps<Theme>
}
